import { render } from "./page-service.vue?vue&type=template&id=27401f92&scoped=true"
import script from "./page-service.vue?vue&type=script&lang=js"
export * from "./page-service.vue?vue&type=script&lang=js"

import "./page-service.vue?vue&type=style&index=0&id=27401f92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27401f92"]])

export default __exports__